export default {
  members(state) {
    return state.members;
  },
};
